import Vue from 'vue';
import Vuex from 'vuex';
import { get } from '@/api/index';
import _ from 'lodash';
import {getCookie} from "@/helper/dom";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showTrialPack: false, // 显示试用会员弹窗
    // 微信分享 获取当前页面链接
    nextPageInfo: {},
    // 付费弹窗或者登录的遮罩层
    overlayShow: false,
    // 登录遮罩层
    loginShow: false,
    // 用户当前level
    // null是未登录
    // 小于100包括100是付费用户
    // 大于100是普通用户
    userLevel: null,
    bindMobile: false,
    yearVipOnly: {},
    userInfo: {},
    // 报名信息
    scopeInfo: {},
    // 客服跳转弹窗
    customShow:false,
    dredgeVipTextList: {
      default: '升级相关权益，即可免费使用直播监控功能、查<br>看历史直播数据及其他尊享服务',
      carrierList: '升级相关权益 <br>即可免费查看所有榜单数据、快手达人<br>详细信息、直播数据、带货数据及其他尊享服务',
      vipOnly: '壁虎看看专业版会员专享功能<br>开通后即可免费使用：壁虎打榜助手、壁虎找人助手、<br>快手直播地图、达人直播封禁查询。',
      carrierListBrand: '壁虎看看专业版会员专享功能<br>可查看各品牌的直播销售排行、销售趋<br/>势、关联达人的销售情况，及其他尊享服务',
      shop: '壁虎看看专业版会员专享功能<br>可查看各店铺的直播销售排行、销售趋<br/>势、关联达人的销售情况，及其他尊享服务',
      liveCalendar: '升级版本权益后<br/>即可查看直播带货等更多数据', // 直播日历查看销售额
      liveCalendarYear: '<div style="color: #4a4a4a;font-weight: 600">壁虎看看年费会员专享功能</div>开通后即可查看该主播对外打赏详情<br/>及其他尊享服务',

      shopAnalysis: '升级相关权益，即可查看主播带货商品品类、<br/>价格定位、上架平台等统计分析及其他尊享服务',
      commodityAnalysis: '升级版本权益后<br/>即可查看更多数据及使用更多功能',
      searchCommodity: '升级相关权益<br/>即可查看商品搜索结果、销售数据及其他尊享服务',
      contact: '壁虎看看专业版会员专享功能<br>开通后即可获得达人授权联系方式及部分达人商务对接服务，<br>并可查看壁虎看看平台主播、品牌、店铺等带货数据详情',
      live: '升级相关权益，即可查看达人直播带货数据、<br>组品分析及其他尊享服务',
      liveYear: '壁虎看看专业版会员专享功能<br>成为年费VIP，即可查看总观看人数、人均停留时长、UV价值、带货转化率，及其他尊享服务',
      monitor: '升级版本权益后<br/>即可跟踪及查看直播相关数据', // 监控达人弹窗文案
      goDatav:'升级版本权益后<br/>即可查看直播大屏及更多数据', // 达人进入直播大屏
      share: '升级相关权益<br/>即可查看和分享直播详情数据，及其他尊享服务', // 达人分享直播卡片
      liveNow:'升级版本权益后<br/>即可查看更多数据和使用更多功能',
      giftOut:'升级版本权益后<br/>即可查看直播对外打赏数据',// 对外打赏
      PkBlock:'升级为专业版会员，即可查看直播PK数据', // pk弹窗
      details:'升级为专业版年费会员，<br/>即可查看品牌、店铺等更多分析数据'
    },
    dredgeVipText: '升级相关权益，即可免费使用直播监控功能、查<br>看历史直播数据及其他尊享服务',
    userLevelList: {
      90: {
        label: '尊享版会员',
      },
      999: {
        label: '试用会员',
      },
      1000: {
        label: '免费版会员',
      },
      100: {
        label: '免费版会员',
      },
      94: {
        label: '专业版会员',
      },
      96: {
        label: '高级版会员',
      },
    },
    platform2index: {
      course: 1,
      taobao: 2,
      jd: 3,
      mokuai: 4,
      youzan: 5,
      suning: 6,
      pdd: 7,
      shangou: 98,
      gifshow: 99,
    },

    index2platform: {
      1: 'course',
      2: 'taobao',
      3: 'jd',
      4: 'mokuai',
      5: 'youzan',
      6: 'suning',
      7: 'pdd',
      98: 'shangou',
      99: 'gifshow'
    },
    platformIndex2chinese: {
      1: '快手课堂',
      2: '淘宝',
      3: '京东',
      4: '魔筷',
      5: '有赞',
      6: '苏宁',
      7: '拼多多',
      98: '闪电购',
      99: '快手小店'
    },
    sourceIconPosition: {
      localLife: {
        name: '本地生活',
        position: '-2.52'
      },
      taobao: {
        name: '淘宝',
        position: '0'
      },
      youzan: {
        name: '有赞',
        position: '-.28'
      },
      mokuai: {
        name: '魔筷',
        position: '-.56'
      },
      xiaodian: {
        name: '小店',
        position: '-.84'
      },
      gifshow: {
        name: '小店',
        position: '-.84'
      },
      jd: {
        name: '京东',
        position: '-1.12'
      },
      shangou: {
        name: '闪电购',
        position: '-1.40'
      },
      pdd: {
        name: '拼多多',
        position: '-1.68'
      },
      suning: {
        name: '苏宁',
        position: '-1.96'
      },
      course: {
        name: '快手课堂',
        position: '-2.24'
      }
    },
    colors: ['#2a89f4', '#54a0f7', '#7ab5f9', '#9fcafb', '#c4dffd', '#e4f0fe', '#5891c1', '#9bd9ee', '#74c2bf',
      '#409f9b', '#32752e', '#7bb46f', '#9eb855', '#d8cf5e', '#f4e298', '#f29300', '#c78051', '#864e53',
      '#b9759d', '#7a82e4', '#5663ad'
    ],
    courseInfo: {},
    // 二维码弹窗
    qrcodeDialog: false,
    customQrcode:'https://s6.bihukankan.com/img/16990050241.png', // 客服二维码
    loginURL: 'https://login.bihukankan.com/mobile?wx_oa_appid=wxc3c24b5b6b23c158&bh_appid=10&redirect_uri=/pages/index/main&redirect_uri_type=wx_mini_reLaunch&redirect_uri=https://m.bihukankan.com&redirect_uri_type=h5',
    logoutURL: 'https://login.bihukankan.com/logout?wx_oa_appid=wxc3c24b5b6b23c158&bh_appid=10&redirect_uri=/pages/index/main&redirect_uri_type=wx_mini_reLaunch&redirect_uri=https://m.bihukankan.com&redirect_uri_type=h5',
    // loginURL: 'http://192.168.2.23:20666/mobile?wx_oa_appid=wxc3c24b5b6b23c158&bh_appid=10&redirect_uri=/pages/index/main&redirect_uri_type=wx_mini_reLaunch&redirect_uri=http://192.168.2.23:60023&redirect_uri_type=h5',
    // logoutURL: 'http://192.168.2.23:20666/logout?wx_oa_appid=wxc3c24b5b6b23c158&bh_appid=10&redirect_uri=/pages/index/main&redirect_uri_type=wx_mini_reLaunch&redirect_uri=http://192.168.2.23:60023&redirect_uri_type=h5'
  },
  getters:{
    isVip: state => state.userLevel && state.userLevel < 1000,
    isYearVip: state => state.userLevel && state.userLevel <= 94,
    isExclusive: state => state.userLevel && state.userLevel <= 90
  },
  mutations: {
    /** 显示试用弹窗 */
    showTrialPackDialog(state,data){
      state.showTrialPack = data
    },
    showQrcodeDialog(state) {
      state.qrcodeDialog = !state.qrcodeDialog
    },
    showCustomDialog(state){
      state.customShow = !state.customShow
    },
    // 判断是登录或者开通vip的弹窗
    // dialog形式出现
    // 当出现年费的时候 第几个不可选，第几个就是true
    // example
    // yearVipOnly: {1: true}
    WRITEOVERLAYSHOW(state, data) {

      state.dredgeVipText = state.dredgeVipTextList[data.textChange || 'default'];
      state.overlayShow = data.status;
      state.bindMobile = data.bindMobile;
      state.yearVipOnly = data.yearVipOnly;
    },
    WRITELOGINSHOW(state, data) {
      state.loginShow = data.status;
    },
    WRITEUSERLEVEL(state, data) {
      state.userLevel = data;
    },
    WRITENEXTPAGE(state, data) {
      state.nextPageInfo = data;
    },
    WRITEUSERINFO(state, data) {
      state.userInfo = data;
    },
    WRITECOURSEINFO(state, data) {
      state.courseInfo = data;
    },
  },
  actions: {
    isVip({ state }, data) {
      return new Promise((resolve, reject) => {
        if (state.userLevel && state.userLevel <= 100) {
          resolve();
        } else {
          this.commit('WRITEOVERLAYSHOW', { status: true, ...data });
          reject({
            isNotVip: true
          });
        }
      });
    },
    isVipYear({ state }) {
      return new Promise((resolve, reject) => {
        // 90是SVIP
        // 94是年费VIP
        // 虽然现在还没有90
        // 2333
        if ([90, 94].indexOf(state.userLevel) >= 0) {
          resolve();
        } else {
          reject({ errCode: 401 });
        }
      });
    },
    getUserInfo({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        if(!getCookie('ssoToken').target) return reject()
        if (!_.isEmpty(state.userInfo)) {
          resolve(state.userInfo);
        } else {
          get({
            road: 'wxUser',
            params: { needInfo: 1 },
            version: 'v3'
          })
            .then(res => {
              const { userLevel } = res
              if (userLevel) {
                commit('WRITEUSERINFO', res);
                commit('WRITEUSERLEVEL',userLevel)
              }
              resolve(res);
            })
            .catch(err => {
              const { code } = err
              if(code === 401){
                commit('WRITEUSERINFO', null)
                commit('WRITEUSERLEVEL',null)
              }
              reject(err);
            });
        }
      });
    },
    getCourseInfo({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        if (!_.isEmpty(state.courseInfo) && Number(data.operationsEventsId) === Number(state.courseInfo.id)) {
          return state.courseInfo;
        } else {
          get({
            road: 'operationsEventsCheckIn',
            data: {
              id: data.operationsEventsId || 7
            },
            params: { userDistributionId: data.userDistributionId },
            version: 'v2'
          }).then(res => {
            commit('WRITECOURSEINFO', res);
            resolve(res);
          }).catch(err => {
            console.log(err);
            reject(err);
          });
        }
      });
    }
  }
});
